import { Outlet } from 'react-router';
import styles from './ShowcaseSurface.module.css';

export function ShowcaseSurface() {
  return (
    <div
      data-crd-id="r6.bq-showcase-surface"
      data-crd-layer="r6"
      className={styles.surface}
    >
      <header className={styles.toolbar}>
        <a href="/" className={styles.logo}>
          <img
            src="/assets/images/logo-white.png"
            alt="BlueQueue"
            className={styles.logoImg}
          />
          <span>CRD Showcase</span>
        </a>
        <nav className={styles.featureNav}>
          <a href="#xray">X-Ray</a>
          <a href="#build">Build With Me</a>
          <a href="#zoom">Layer Zoom</a>
          <a href="#diff">Diff</a>
          <a href="#tuner">Token Tuner</a>
          <a href="/designer">Token Studio</a>
        </nav>
      </header>
      <Outlet />
    </div>
  );
}
